/* eslint-disable vue/valid-v-model */
<template>
    <a-modal
        :footer="null"
        closable
        maskClosable
        :width="900"
        :zIndex="80000"
        v-model="isActive">

        <h5 class="mb-4 pr-10">Ajuste nos dados da nota pendente  <span style="float: right; opacity: 0.1"> {{ invoice.id }} </span></h5> 

        <div class="">Chave: {{ invoice.key }}</div>
        <div class="mb-4">Número: {{ invoice.docFiscal.numeroNota }}</div>

        <!-- <div class="vx-col w-full mb-base">
            <div class="vx-row">
                <div class="vx-col w-full mb-2">
                    <DatePicker format="dd/MM/yyyy" v-model="date"></DatePicker>
                </div>
                <div class="vx-col w-full mt-3">
                    {{ date | dateFormat('HH:mm:ss') }}
                </div>
            </div>
        </div> -->

        <h6 class="mb-2">Produtos da nota:</h6>

        <vs-collapse type="border">
            <vs-collapse-item v-for="product in draftInvoice.produtos" :key="product.numeroItem">

                <div slot="header"> {{ product.numeroItem }} - {{ product.prod.descricao }}</div>
                
                <FiscalProductInfo :product="product"/>

                <vs-divider />
                
                <!-- <vs-checkbox class="mb-3" v-model="valueIsHomogenious">Valor e quantidade se aplicam tanto ao comercial e tributável</vs-checkbox> -->
                <div class="vx-col w-full mb-base">
                    <div class="vx-row">
                        <div class="vx-col w-full mb-2">
                            <vs-input v-validate.initial="{required : true}" class="w-full" icon-no-border label="Valor unitario comercial" v-model="product.prod.valorUnitarioComercial"></vs-input>
                        </div>
                        <div class="vx-col w-full mb-2">
                            <vs-input v-validate.initial="{required : true}" class="w-full" icon-no-border label="Valor unitario tributavel" v-model="product.prod.valorUnitarioTributavel"></vs-input>
                        </div>
                    </div>
                     <div class="vx-row">
                        <div class="vx-col w-full mb-2">
                            <vs-input v-validate.initial="{required : true}" class="w-full" icon-no-border label="Valor total" v-model="product.prod.valorTotal"></vs-input>
                        </div>
                        <!-- <div class="vx-col w-full mb-2">
                            <vs-input v-validate.initial="{required : true}" class="w-full" icon-no-border label="Quantidade" v-model="product.prod.quantidadeComercial"></vs-input>
                        </div> -->
                    </div>
                </div>

            </vs-collapse-item>
        </vs-collapse>

        <vs-divider />

        <div class="vx-col w-full mb-base">
                <div class="vx-row">
                <div class="vx-col w-full mb-2">
                    <vs-input v-validate.initial="{required : true}" name="Valor da nota" class="w-full" icon-no-border label="Valor da nota" v-model="draftInvoice.total.icmsTot.vNF"></vs-input>
                </div>
                <div class="vx-col w-full mb-2">
                    <vs-input v-validate.initial="{required : true}" name="Valor em produtos" class="w-full" icon-no-border label="Valor em produtos" v-model="draftInvoice.total.icmsTot.vProd"></vs-input>
                </div>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full mt-8" style="display: flex; justify-content: space-between;">
                <div>
                    <vs-button :disabled="noChangeHasBeenMade || busy"
                        @click="save"
                        class="mr-3 mb-2">Alterar</vs-button>
                    <span class="text-primary" style="opacity: 0.4"
                        v-show="noChangeHasBeenMade && !busy">Sem alterações detectadas</span>
                    <span class="text-primary" style="opacity: 0.4"
                        v-show="busy">Salvando...</span>
                </div>
                <vs-button v-if="invoice.disposedAt"
                    :disabled="busy"
                    @click="resend"
                    class="mr-3 mb-2">Enviar como nova</vs-button>
            </div>
        </div>
    </a-modal>
</template>

<script>
    import * as cloneDeep from 'lodash.clonedeep';
    import * as isEqual from 'lodash.isequal';
    import firebase from '@/firebase/firebase'
    import { httpsCallable } from "@/firebase/functions";
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import Bugsnag from '@bugsnag/js';
    import DatePicker from '../../components/DatePicker';
    import FiscalProductInfo from '../../components/fiscal/FiscalProductInfo';

    const db = firebase.firestore();

    export default {
        components: {
            DatePicker,
            FiscalProductInfo
        },
        props: {
            value: {
                type: Boolean,
            },
            invoice: Object
        },
        data() {
            return {
                draftInvoice: null,
                busy: false,
                valueIsHomogenious: true
            }
        },
        computed: {
            isActive: {
                get () {
                    return this.value;
                },
                set (v) {
                    this.$emit('input', v);
                }
            },
            date: {
                get () {
                    return new Date(this.draftInvoice.docFiscal.dhContingencia);
                },
                set (v) {
                    this.draftInvoice.docFiscal.dhContingencia = moment(v).utcOffset('-0300').format();
                    console.log(this.draftInvoice.docFiscal.dhContingencia);
                    this.draftInvoice.backupedAt = v;
                }
            },
            noChangeHasBeenMade () {
                return isEqual(this.invoice, this.draftInvoice);
            },
            ...mapGetters(['getCompanyID'])
        },
        methods: {
            async save () {
                if (this.noChangeHasBeenMade)
                    return;
                try {
                    this.busy = true;
                    const { getCompanyID } = this;
                    const ref = db.collection(`company/${getCompanyID}/invoice`).doc(this.invoice.id);
                    await ref.set(this.draftInvoice);
                    this.$message.success('Informações alteradas com sucesso!', 5)
                } catch (err) {
                    this.setError(err);
                }
                this.busy = false;
                this.isActive = false;
            },
            async resend () {
                try {
                    this.busy = true;
                    const { getCompanyID, invoice } = this;
                    let sendFromDisposal = httpsCallable('sendFromDisposal');
                    const result = await sendFromDisposal({ companyId : getCompanyID, invoiceId: invoice.id });
                    if (result && result.data.success)
                        this.$success({
                            zIndex : 999999,
                            title: 'Reenviado com sucesso!',
                            content: `Nota enviada: ${result.data.number} - Chave: ${result.data.key}`
                        });
                        this.$message.success('Reenviado com sucesso!', 5)
                } catch (err) {
                    this.setError(err);
                }
                this.busy = false;
                this.isActive = false;
            },
            setError (err, title) {
                Bugsnag.notify(err);
                console.log(err);
                this.$error({
                    zIndex : 999999,
                    title: title || err.message || 'Erro ao enviar nota(s)',
                    content: err.details
                });
            },
        },
        beforeMount () {
            this.draftInvoice = cloneDeep(this.invoice);
        }
    }
</script>

<style lang="scss" scoped>

</style>